/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/


import {FETCH_ADDITIONAL_DOCUMENT_REQUEST, FETCH_ADDITIONAL_DOCUMENT_SUCCESS, FETCH_ADDITIONAL_DOCUMENT_FAILURE, FETCH_DELETE_ADDITIONAL_DOCUMENT_REQUEST, FETCH_DELETE_ADDITIONAL_DOCUMENT_SUCCESS, FETCH_DELETE_ADDITIONAL_DOCUMENT_FAILURE} from './AdditionalDocumentTypes';

const initialState={
    loading:false,
    additionalDocument:{},
    error:''
}

const applicationAdditonalDocumentReducer = (state=initialState, action)=>{
    switch(action.type){
        case FETCH_ADDITIONAL_DOCUMENT_REQUEST:
            return{
                ...state,
                loading:true
                }
            
        case FETCH_ADDITIONAL_DOCUMENT_SUCCESS:
            return{
                loading:false,
                additionalDocument:action.payload,
                error:''
            }
        case FETCH_ADDITIONAL_DOCUMENT_FAILURE:
        case FETCH_DELETE_ADDITIONAL_DOCUMENT_FAILURE:
            return{
                loading:false,
                additionalDocument:{},
                error:action.payload
            }
        case FETCH_DELETE_ADDITIONAL_DOCUMENT_REQUEST:
        case FETCH_DELETE_ADDITIONAL_DOCUMENT_SUCCESS:
            return{
                loading:false,
                additionalDocument:{},
                error:''
            }
        
        default:
            return state;
    }
}

export default applicationAdditonalDocumentReducer ;